import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-slate-800 text-center text-white" aria-label="Limited time offer" data-id="element-272" data-mp="369pga49jt16e">
      <div className="metal-rule h-1.5 w-full" aria-hidden="true" data-id="element-273" data-mp="31j8zca6iqxfa" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-274" data-mp="31hxzglg729tg">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-slate-200" data-id="element-275" data-mp="3g7cadxzf4zay">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-276" data-mp="3b7zeyouhejwr" /> Launch pricing ends in
        </p>
        <Countdown className="mt-5" data-id="element-277" data-mp="3p7ikraztlj5w" />
        <p className="mt-7 font-bold text-slate-100" data-id="element-278" data-mp="3p6h8j372iqml">After that the price increases and never drops again.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-slate-400/20 bg-slate-950 p-4 text-sm" data-id="element-279" data-mp="1uusq2r1mo5xg">
          <p className="font-bold text-white" data-id="element-280" data-mp="1qtgywh33vcn5">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-slate-200" data-id="element-281" data-mp="1qus0ca92w8b3" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-slate-800" data-id="element-282" data-mp="2xrzlc9pwjnzb">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="metal h-full rounded-full" data-id="element-283" data-mp="32s411xizkeoh" />
          </div>
          <p className="mt-1 text-right text-xs text-slate-300" data-id="element-284" data-mp="3giz42t6t01k5">66% of spots taken</p>
        </div>
      </div>
      <div className="metal-rule h-1.5 w-full" aria-hidden="true" data-id="element-285" data-mp="3lhtxep2ed8ii" />
    </section>;
}